import { useGetVipProgress, useMonthlyBonus } from 'react-render-hooks';
import { ReturnTypeMonthlyBonus } from 'react-memory-optimization/dist/lib/store/operations/entities/vipClub/types';

import RakeBackCard from './components/RakeBackCard';
import WeeklyCard from './components/WeeklyCard';
import MonthlyCard from './components/MonthlyCard';

import { getUserCurrencyIdSelector } from 'stores/user/personal/selectors';
import { getLoyaltyWagerSelector } from 'stores/user/balance/selectors';
import { useZustandBalanceStore } from 'stores/user/balance/store';
import { useZustandUserStore } from 'stores/user/personal/store';

import { useHookFabric } from 'hooks/useHookFabric';
import { getNext15thDate } from 'utils/date';

const VipBonuses = ({ isAvailable = true }: { isAvailable?: boolean }) => {
  const { level = { current: 0, next: 0 } } =
    useHookFabric<{
      level: { current: number; next: number };
      percent: number;
    }>({
      fn: useGetVipProgress,
      customProps: {},
    }) || {};

  const month = useHookFabric<ReturnTypeMonthlyBonus>({
    fn: useMonthlyBonus,
  });

  return (
    <>
      {isAvailable && <RakeBackCard />}

      {isAvailable && Boolean(level.current) && <WeeklyCard />}

      {isAvailable && Boolean(level.current) && (
        <MonthlyCard
          info={{
            resultValue: month?.amount || 0,
            endTimestamp: month?.endData || getNext15thDate(),
          }}
          id={month?.id || 0}
        />
      )}

      {!isAvailable && <WeeklyCard isAvailable={false} />}

      {!isAvailable && (
        <MonthlyCard
          info={{
            resultValue: 0,
            endTimestamp: getNext15thDate(),
          }}
          id={0}
          isAvailable={false}
        />
      )}
    </>
  );
};

export default VipBonuses;
